import { render, staticRenderFns } from "./tableModel.vue?vue&type=template&id=989f246c&scoped=true&"
import script from "./tableModel.vue?vue&type=script&lang=ts&"
export * from "./tableModel.vue?vue&type=script&lang=ts&"
import style0 from "./tableModel.vue?vue&type=style&index=0&id=989f246c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989f246c",
  null
  
)

export default component.exports